module.exports = __webpack_public_path__ + "media/images/modules/publisher/steps/3-1378a70256c14bfdb4b32e140dc30417.png";